import './assets/main.css'
import './assets/styles/mobile-variables.css'
import './assets/styles/mobile-base.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
// import naive from 'naive-ui' // 全域引入 Naive UI，如果使用 unplugin-vue-components 按需引入，這行可以考慮移除或註解

import App from './App.vue'
import router from './router'
import { initializeApiConfig } from '@/config/apiConfig'
import { logger } from '@/utils/logger'
import { useCartStore } from '@/stores/cartStore'

const app = createApp(App)

// 初始化日誌系統
logger.init()

// 初始化 API 配置
await initializeApiConfig()

// 開發環境設定
if (import.meta.env.DEV) {
  // 啟用 Vue DevTools 和效能追蹤
  app.config.performance = true
  app.config.globalProperties.$debugMode = true
  
  // 啟動 MSW 模擬服務
  const { worker } = await import('./mocks/browser')
  await worker.start({
    onUnhandledRequest: (req, print) => {
      // 過濾邏輯：智能處理 API 請求
      const url = new URL(req.url)
      
      // 忽略靜態資源請求
      const staticFileExtensions = ['.js', '.css', '.png', '.jpg', '.jpeg', '.gif', '.svg', '.ico', '.woff', '.woff2', '.ttf', '.eot']
      const isStaticFile = staticFileExtensions.some(ext => url.pathname.endsWith(ext))
      
      // 忽略 Vite 開發相關的請求
      const isViteRequest = url.pathname.startsWith('/@') || 
                           url.pathname.startsWith('/src/') ||
                           url.pathname.startsWith('/node_modules/') ||
                           url.pathname === '/favicon.ico'
      
      // 忽略外部請求（非 localhost 的請求）
      const isExternalRequest = url.hostname !== 'localhost' && url.hostname !== '127.0.0.1'
      
      // 檢查是否為真實 API 請求 (基於環境變數 VITE_API_BASE_URL)
      const realApiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080'
      const realApiUrl = new URL(realApiBaseUrl)
      const isRealApiRequest = url.hostname === realApiUrl.hostname && url.port === realApiUrl.port
      
      // 只對模擬 API 請求（相對路徑）顯示警告，其他請求靜默通過
      if (!isStaticFile && !isViteRequest && !isExternalRequest && url.pathname.startsWith('/api') && !isRealApiRequest) {
        logger.warn(`MSW handler not found: ${req.method} ${url.pathname}`)
        print.warning()
      }
      
      // 對其他請求（靜態文件、外部請求、真實 API）保持靜默通過
    }
  })
  
  logger.info('Vue Debug mode enabled')
  logger.info('MSW mock API started')
  
  // 載入 QRCode 流程測試工具
  import('./utils/testQRCodeFlow').then(({ qrCodeFlowTester }) => {
    (window as any).qrCodeFlowTester = qrCodeFlowTester
    logger.info('QRCode 流程測試工具已載入，請在控制台使用: qrCodeFlowTester.runCompleteFlow()')
  })
}

app.use(createPinia())
app.use(router)
// app.use(naive) // 如果使用 unplugin-vue-components 按需引入，這行可以考慮移除或註解

// 購物車將在使用者登入且為前台角色時才初始化
// 見 @/composables/useCartInit.ts 或相關登入處理邏輯

app.mount('#app')
